import { Navigate, Route, Routes } from 'react-router-dom';

import AnalyticsPage from 'modules/analytics/page/AnalyticsPage';
import { CoursesPage, ExercisesPage, LessonsPage } from 'modules/dashboard/pages';
import AddAssessmentPage from 'modules/dashboard/pages/AddAssessmentPage';
import { AddCoursePage } from 'modules/dashboard/pages/AddCoursePage';
import { AddExercisesPage } from 'modules/dashboard/pages/AddExercisesPage';
import AddFunctionalTestPage from 'modules/dashboard/pages/AddFunctionalTestPage';
import { AddLessonPage } from 'modules/dashboard/pages/AddLessonPage';
import AssessmentsPage from 'modules/dashboard/pages/AssessmentsPage';
import FunctionalTestsPage from 'modules/dashboard/pages/FunctionalTestsPage';
import { InstitutionInfoLayout } from 'modules/institution-info/components/InstitutionInfoLayout';
import GeneralPage from 'modules/institution-info/pages/GeneralPage';
import StationsPage from 'modules/institution-info/pages/StationsPage';

import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import { AddInstitutionPage } from './page/AddInstitutionPage';
import { InstitutionsPage } from './page/InstitutionsPage';

const InstitutionsRoutes = () => (
  <Routes>
    <Route>
      <Route index element={<InstitutionsPage />} />
      <Route path={`${PATH.ADD_INSTITUTIONS}`} element={<AddInstitutionPage />} />
      <Route path={PATH.INSTITUTION_DETAIL} element={<InstitutionInfoLayout />}>
        <Route path={PATH.INSTITUTION_GENERAL} element={<GeneralPage />} />
        <Route path={PATH.INSTITUTION_STATIONS} element={<StationsPage />} />
        <Route path={PATH.EXERCISES} element={<ExercisesPage />} />
        <Route path={PATH.LESSONS} element={<LessonsPage />} />
        <Route path={PATH.COURSES} element={<CoursesPage />} />
        <Route path={PATH.FUNCTIONAL_TESTS} element={<FunctionalTestsPage />} />
        <Route path={PATH.ASSESSMENTS} element={<AssessmentsPage />} />
        <Route path={PATH.INSTITUTION_ANALYTICS} element={<AnalyticsPage />} />

        <Route index element={<Navigate to={PATH.INSTITUTION_GENERAL} />} />
      </Route>

      <Route path={PATH.INSTITUTION_DETAIL}>
        <Route path={`${PATH.EXERCISES}/${PATH.ADD_EXERCISES}`} element={<AddExercisesPage />} />
        <Route path={`${PATH.EXERCISES}/${PATH.EDIT_EXERCISES}`} element={<AddExercisesPage />} />
        <Route path={`${PATH.LESSONS}/${PATH.ADD_LESSONS}`} element={<AddLessonPage />} />
        <Route path={`${PATH.LESSONS}/${PATH.EDIT_LESSONS}`} element={<AddLessonPage />} />
        <Route path={`${PATH.COURSES}/${PATH.ADD_COURSES}`} element={<AddCoursePage />} />
        <Route path={`${PATH.COURSES}/${PATH.EDIT_COURSES}`} element={<AddCoursePage />} />
        <Route
          path={`${PATH.FUNCTIONAL_TESTS}/${PATH.ADD_FUNCTIONAL_TESTS}`}
          element={<AddFunctionalTestPage />}
        />
        <Route
          path={`${PATH.FUNCTIONAL_TESTS}/${PATH.EDIT_FUNCTIONAL_TESTS}`}
          element={<AddFunctionalTestPage />}
        />

        <Route
          path={`${PATH.ASSESSMENTS}/${PATH.ADD_ASSESSMENTS}`}
          element={<AddAssessmentPage />}
        />
        <Route
          path={`${PATH.ASSESSMENTS}/${PATH.EDIT_ASSESSMENTS}`}
          element={<AddAssessmentPage />}
        />
      </Route>
      <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
    </Route>
  </Routes>
);

export default withPermission(['Institutions'])(InstitutionsRoutes);
